import { Component, type ErrorInfo, type ReactNode } from 'react'

/**
 * Перехват ошибок отрисовки.
 *
 * Без него любая ошибка в компоненте оставляет пустой белый экран, и человек
 * не понимает, сломалось ли приложение или просто нет данных. Текст ошибки
 * показывается: молча подменять его словами «что-то пошло не так» — значит
 * лишить того, кто будет разбираться, единственной зацепки.
 */
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  override state: { error: Error | null } = { error: null }

  static getDerivedStateFromError(error: Error): { error: Error } {
    return { error }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Ошибка отрисовки', error, info.componentStack)
  }

  override render(): ReactNode {
    if (!this.state.error) return this.props.children

    return (
      <div style={{ padding: 40, maxWidth: 720, margin: '0 auto' }}>
        <div className="panel">
          <div className="panel__body" style={{ paddingTop: 18 }}>
            <h2 style={{ marginBottom: 8 }}>Страница не отрисовалась</h2>
            <p className="secondary" style={{ marginBottom: 14 }}>
              Данные могли загрузиться, но интерфейс не смог их показать. Ошибка ниже —
              её стоит передать разработчику.
            </p>
            <pre
              className="small"
              style={{
                background: 'var(--surface-sunken)',
                border: '1px solid var(--line)',
                borderRadius: 'var(--radius-sm)',
                padding: 12,
                overflowX: 'auto',
                marginBottom: 16,
              }}
            >
              {this.state.error.message}
            </pre>
            <div className="row">
              <button className="btn btn--primary" onClick={() => this.setState({ error: null })}>
                Попробовать снова
              </button>
              <a className="btn" href="/">
                На главную
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
